// extracted by mini-css-extract-plugin
export default {"leftMessageContainer":"styles_leftMessageContainer__EqM3w","rightMessageContainer":"styles_rightMessageContainer__FRAAB"};